"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "DryError", {
  enumerable: true,
  get: function get() {
    return _kmsErrors.DryError;
  }
});
_Object$defineProperty(exports, "KMS", {
  enumerable: true,
  get: function get() {
    return _kms.default;
  }
});
_Object$defineProperty(exports, "KmsError", {
  enumerable: true,
  get: function get() {
    return _kmsErrors.KmsError;
  }
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _encryption.default;
  }
});
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _has2 = _interopRequireDefault(require("lodash/has"));
require("@webex/internal-plugin-device");
require("@webex/internal-plugin-mercury");
var _webexCore = require("@webex/webex-core");
var _encryption = _interopRequireDefault(require("./encryption"));
var _config = _interopRequireDefault(require("./config"));
var _kmsErrors = require("./kms-errors");
var _kmsDryErrorInterceptor = _interopRequireDefault(require("./kms-dry-error-interceptor"));
var _kms = _interopRequireDefault(require("./kms"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

// Note: There's a bug where if bind gets replayed because of a timeout in which
// the original request eventually completed, there'll be an error indicating
// the key can't be bound (because it already has been). This could be mitigated
// by using Promise.race to resolve replays (as more requests get enqueue for a
// specific action, accept whichever one completes first).

var interceptors;
if (process.env.NODE_ENV === 'test') {
  interceptors = {
    KmsDryErrorInterceptor: _kmsDryErrorInterceptor.default.create
  };
}
(0, _webexCore.registerInternalPlugin)('encryption', _encryption.default, {
  payloadTransformer: {
    predicates: [{
      name: 'encryptKmsMessage',
      direction: 'outbound',
      // I don't see any practical way to reduce complexity here.
      // eslint-disable-next-line complexity
      test: function test(ctx, options) {
        if (!(0, _has2.default)(options, 'body.kmsMessage')) {
          return _promise.default.resolve(false);
        }
        if (!(0, _isObject2.default)(options.body.kmsMessage)) {
          return _promise.default.resolve(false);
        }

        // If this is a template for a kms message, assume another transform
        // will fill it in later. This is a bit of a leaky abstraction, but the
        // alternative is building a complex rules engine for controlling
        // ordering of transforms
        if (options.body.kmsMessage.keyUris && options.body.kmsMessage.keyUris.length === 0) {
          return _promise.default.resolve(false);
        }
        if (options.body.kmsMessage.resourceUri && (options.body.kmsMessage.resourceUri.includes('<KRO>') || options.body.kmsMessage.resourceUri.includes('<KEYURL>'))) {
          return _promise.default.resolve(false);
        }
        if (options.body.kmsMessage.uri && (options.body.kmsMessage.uri.includes('<KRO>') || options.body.kmsMessage.uri.includes('<KEYURL>'))) {
          return _promise.default.resolve(false);
        }
        return _promise.default.resolve(true);
      },
      extract: function extract(options) {
        return _promise.default.resolve(options.body);
      }
    }, {
      name: 'decryptKmsMessage',
      direction: 'inbound',
      test: function test(ctx, response) {
        return _promise.default.resolve((0, _has2.default)(response, 'body.kmsMessage') && (0, _isString2.default)(response.body.kmsMessage));
      },
      extract: function extract(response) {
        return _promise.default.resolve(response.body);
      }
    }, {
      name: 'decryptErrorResponse',
      direction: 'inbound',
      test: function test(ctx, reason) {
        return _promise.default.resolve(Boolean(reason.body && reason.body.errorCode === 1900000));
      },
      extract: function extract(reason) {
        return _promise.default.resolve(reason);
      }
    }],
    transforms: [{
      name: 'encryptKmsMessage',
      fn: function fn(ctx, object) {
        if (!object) {
          return _promise.default.resolve();
        }
        if (!object.kmsMessage) {
          return _promise.default.resolve();
        }
        if ((0, _isString2.default)(object.kmsMessage)) {
          return _promise.default.resolve();
        }
        return ctx.webex.internal.encryption.kms.prepareRequest(object.kmsMessage).then(function (req) {
          object.kmsMessage = req.wrapped;
        });
      }
    }, {
      name: 'decryptKmsMessage',
      fn: function fn(ctx, object) {
        return ctx.webex.internal.encryption.kms.decryptKmsMessage(object.kmsMessage).then(function (kmsMessage) {
          object.kmsMessage = kmsMessage;
        });
      }
    }, {
      name: 'decryptErrorResponse',
      fn: function fn(ctx, reason) {
        var promises = reason.body.errors.map(function (error) {
          return ctx.webex.internal.encryption.kms.decryptKmsMessage(error.description).then(function (desc) {
            error.description = desc;
          });
        });
        promises.push(ctx.webex.internal.encryption.kms.decryptKmsMessage(reason.body.message).then(function (kmsMessage) {
          reason.body.message = kmsMessage;
        }));
        return _promise.default.all(promises).then(function () {
          return _promise.default.reject(new _kmsErrors.DryError(reason));
        });
      }
    }]
  },
  interceptors: interceptors,
  config: _config.default
});
//# sourceMappingURL=index.js.map
